export default {
  'menu.login': "Login",
  'menu.auth': 'Auth',
  'menu.home': 'Home',
  'menu.account': 'Account',
  'menu.account.settings': 'Account Setting',
  'menu.ev_charger': 'EvCharger Manage',
  'menu.ev_charger.ev_charger': 'EvCharger',
  'menu.ev_charger.device': 'Device',
  'menu.ev_charger.device.create': 'Create EvCharger',
  'menu.ev_charger.device.info': 'EvCharger Info',
  'menu.ev_charger.schedule': 'Payment Schedule',
  'menu.ev_charger.publicHoliday': 'Public Holiday',
  'menu.ev_charger.publicHolidayInfo': 'Public Holiday Info',
  'menu.ev_charger.publicHolidayCreate': 'Create Public Holiday',
  'menu.ev_charger.promotion': 'Promotion',
  'menu.ev_charger.location': "Location",
  'menu.user': 'User Manage',
  'menu.user.admin': 'Admin',
  'menu.user.users': 'Users',
  'menu.user.createUsers': "Create Users",
  'menu.user.appusers': "APP Users",
  'menu.user.delappusers': "Deleted App Users",
  'menu.user.userinfo': 'User Info',
  'menu.advertising': 'Advertising Manage',
  'menu.advertising.playlist.info': 'Advertising Info',
  'menu.advertising.playlist': 'Playlist',
  'menu.advertising.playlist.create': 'Create Playlist',
  'menu.advertising.mobile_adv.info': 'Mobile Advertising Info',
  'menu.advertising.mobile_adv': 'Mobile Advertising',
  'menu.advertising.mobile_adv.create': 'Create Mobile Advertising',
  'menu.advertising.document': 'Document',
  'menu.advertising.document.upload': 'Upload Document',
  'menu.transaction': 'Transaction',
  'menu.report': 'Reports',
  'menu.location': 'location',
  'menu.ev_charger.deviceInfo': 'Device Info',
  'menu.ev_charger.deviceCreate': 'Create Device',
  'menu.ev_charger.scheduleCreate': 'Create Schedule',
  'menu.ev_charger.scheduleInfo': 'Schedule Info',
};
